<template>
  <transition
    enter-active-class="transition-opacity duration-250"
    leave-active-class="transition-opacity duration-250"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
    @before-enter="beforeEnterCallback"
    @after-enter="afterEnterCallback"
    @before-leave="beforeLeaveCallback"
    @after-leave="afterLeaveCallback"
  >
    <div
      class="fixed inset-0 overflow-y-auto py-10 z-10 bg-black-50"
      v-if="open"
      @click.self="clickDismissible && $emit('close')"
    >
      <!-- Removed .h-full due to Chrome 90 bug -->
      <div
        class="flex flex-col justify-center w-full m-auto"
        :style="`max-width: ${maxWidth}`"
      >
        <div class="relative w-full max-h-full">
          <slot name="trigger" v-bind="{ triggerModalClose }"></slot>

          <slot v-bind="{ triggerModalClose }"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',

  props: {
    dismissible: {
      default: true,
      type: Boolean,
    },

    clickDismissible: {
      default: function() {
        return this.dismissible;
      },
      type: Boolean,
    },

    escDismissible: {
      default: function() {
        return this.dismissible;
      },
      type: Boolean,
    },

    maxWidth: {
      default: '32rem',
      type: String,
    },

    open: {
      default: false,
      type: Boolean,
    },

    preventBackgroundScrolling: {
      default: true,
      type: Boolean,
    },

    beforeEnterCallback: {
      default: () => {},
      type: Function,
    },

    afterEnterCallback: {
      default: () => {},
      type: Function,
    },

    beforeLeaveCallback: {
      default: () => {},
      type: Function,
    },

    afterLeaveCallback: {
      default: () => {},
      type: Function,
    },
  },

  mounted() {
    if(this.escDismissible) {
      document.addEventListener('keydown', this.onEscape);
    }
  },

  destroyed() {
    if(this.escDismissible) {
      document.removeEventListener('keydown', this.onEscape);
    }
  },

  methods: {
    onEscape(event) {
      if (!this.open || event.keyCode !== 27) { // escape
        return;
      }

      this.triggerModalClose();
    },

    triggerModalClose() {
      this.$emit('close');
    }
  },

  watch: {
    open: {
      immediate: true,
      handler(state) {
        if(this.preventBackgroundScrolling) {
          if(state) {
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
          } else {
            document.documentElement.style.removeProperty('overflow');
            document.body.style.removeProperty('overflow');
          }
        }
      },
    },
  },
}
</script>
